import React from "react";
import AboutUs from "../../Components/About/about";
import Gallery from '../../Components/Gallery/gallery';
import img from '../../Components/Images/image.webp';
import img1 from '../../Components/Images/image1.webp';
import img2 from '../../Components/Images/image2.webp';
import img3 from '../../Components/Images/image3.webp';
import img4 from '../../Components/Images/image4.webp';
import img5 from '../../Components/Images/image5.webp';

const About = () => {
    const images = [
        {
            src: img,
            alt: "Image"
        },
        {
            src: img1,
            alt: "Image"
        }, {
            src: img2,
            alt: "Image"
        }, {
            src: img3,
            alt: "Image"
        }, {
            src: img4,
            alt: "Image"
        }, {
            src: img5,
            alt: "Image"
        },

    ]
    return (
        <div>
            <AboutUs />
            <Gallery images={images} />
        </div>
    )
}

export default About;